import store from "@/store/index"

export default (error) => {
   if(store.getters['auth/isLogedIn']) {
       store.dispatch('auth/logout')
   }
}